/**
 * @format
 */

 export const LOADING_USER_DETAILS = 'loading_user_details';
 export const SET_USER = 'set_user';
 export const ADD_USER = 'add_user';
 export const LOADING_USER = 'loading_user';
